import React from "react";
import Icon from "components/AppIcon";

const StatsBar = ({ stats }) => {
  const items = [
    { label: "Actualizaciones asignadas", value: stats?.total, icon: "Package", color: "var(--color-primary)" },
    { label: "Disponibles", value: stats?.disponibles, icon: "Download", color: "var(--color-success)" },
    { label: "Descargadas", value: stats?.descargadas, icon: "CheckCircle", color: "var(--color-secondary)" },
    { label: "Por vencer (7 días)", value: stats?.porVencer, icon: "Clock", color: "var(--color-warning)" },
  ];

  return (
    <div className="grid grid-cols-2 lg:grid-cols-4 gap-3 md:gap-4">
      {items?.map((item) => (
        <div
          key={item?.label}
          className="rounded-xl border bg-white p-3 md:p-4 flex items-center gap-3"
          style={{ borderColor: "var(--color-border)", boxShadow: "var(--shadow-sm)" }}
        >
          <div
            className="w-10 h-10 rounded-lg flex items-center justify-center flex-shrink-0"
            style={{ backgroundColor: `${item?.color}15` }}
          >
            <Icon name={item?.icon} size={18} color={item?.color} />
          </div>
          <div className="min-w-0">
            <p className="text-xl md:text-2xl font-bold" style={{ fontFamily: "var(--font-heading)", color: "var(--color-foreground)" }}>
              {item?.value}
            </p>
            <p className="text-xs line-clamp-2" style={{ color: "var(--color-muted-foreground)", fontFamily: "var(--font-caption)" }}>
              {item?.label}
            </p>
          </div>
        </div>
      ))}
    </div>
  );
};

export default StatsBar;